import React from 'react';
import { useAccessibilityPreferences } from '@/features/profile/hooks/use-accessibility-preferences';

interface AccessibilityProviderProps {
  children: React.ReactNode;
}

/**
 * AccessibilityProvider Component
 * Task 22.3: Updated to use new Bulletproof React hook location
 *
 * Initializes accessibility preferences on app load.
 * This ensures that saved accessibility settings are applied as soon as the app loads.
 */
export function AccessibilityProvider({ children }: AccessibilityProviderProps) {
  // Initialize accessibility preferences - this will load from database and apply CSS classes
  useAccessibilityPreferences();

  return <>{children}</>;
}
